import React from 'react';

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Wraps every case-insensitive occurrence of `term` in `text` with <mark>.
export const highlightText = (text, term, className) => {
  if (!term) return text;
  return text.split(new RegExp(`(${escapeRegExp(term)})`, 'gi')).map((part, i) =>
    part.toLowerCase() === term.toLowerCase() ? (
      <mark key={i} className={className}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};
